import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *题库列表
 * @param params
 * 
*/

export const questionList = params => Http.get(`${baseUrl}/question`, { params })

/**
 *题目详情
 * @param id
 * 
*/

export const getInfo = id => Http.get(`${baseUrl}/question/${id}`)

/**
 *题目详情（多个）
 * @param ids
 * 
*/

export const questionInfo = ids => Http.get(`${baseUrl}/question/${ids}/info`)

/**
 *修改题目
 * @param params
 * 
*/

export const editQuestion = params => Http.put(`${baseUrl}/question`, params)

/**
 *新增题目
 * @param params
 * 
*/

export const addQuestion = params => Http.post(`${baseUrl}/question`, params)

/**
 *删除题目
 * @param id
 * 
*/

export const delQuestion = id => Http.delete(`${baseUrl}/question/${id}`)

/**
 *导入题目
 * @param params
 * 
*/

export const importQuestion = params => Http.post(`${baseUrl}/question/${params.courseId}/import`, params.file )
